//
//
//
//
//
//
//
//
//
//

import { mdiCloseCircleOutline } from '@mdi/js'

export default {
  setup() {
    return {
      icons: {
        mdiCloseCircleOutline,
      },
    }
  },
}
